import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Modal } from "semantic-ui-react";
import AthleteSummary from "../../athletes/AthleteSummary";
import AthleteShortSummary from "./AthleteShortSummary";
import ViewToggle from "./ViewToggle";

const AthleteReminderList = (props) => {
  const [defaultView, setDefaultView] = useState(true);
  const [view, setView] = useState(true);
  const handleClick = (e) => {
    if (e === "detailed") setDefaultView(false);
    if (e === "default") setDefaultView(true);
  };
  useEffect(() => {
    const athletes = props.athletes;
   // console.log("athletes list", athletes);
    if (athletes && athletes.length > 0) {
      const tempArray = athletes.filter(e => e !== undefined );
      if (tempArray.length < 1) {
        setView(false);
      } else setView(true);
    }
  }, [props.athletes]);

  return (
    <Modal
      open={props.open}
      onClose={props.close}
      closeIcon
      // size={defaultView ? "tiny" : "small"}
      size="tiny"
      className="eventVisitorModal tiny reminder-admin-list-modal"
    >
      <Modal.Content scrolling>
        {/* <div className="eventVisitorModalButton">
          <Button floated="left" circular icon="close" onClick={props.close} />
        </div> */}
        <div className="list">
          {view && <ViewToggle click={handleClick} defaultView={defaultView} />}
          <ul>
            {defaultView
              ? props.athletes.map((ath, i) => (
                ath !== undefined && (<AthleteShortSummary ath={ath} key={i} />)
                ))
              : props.athletes.map((ath, i) => (
                ath !== undefined && (
                  <Link
                    to={`/athletes/${ath.customUrl}`}
                    target="_blank"
                    key={i}
                  >
                    <AthleteSummary
                      athlete={ath}
                      key={ath.customUrl}
                      athleteKey={ath.id}
                    />
                  </Link>
                )
                  
                ))}
          </ul>
        </div>
      </Modal.Content>
    </Modal>
  );
};

export default AthleteReminderList;
